export default __webpack_public_path__ + "static/media/line.bd2f6589.svg";